"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferComponents = exports.OfferModels = void 0;
const offer_1 = __importDefault(require("./offer"));
const offer_main_price_1 = require("./offer-main-price");
const offer_type_1 = require("./offer-type");
exports.OfferModels = [
    offer_1.default,
];
exports.OfferComponents = [
    offer_type_1.OfferType,
    offer_main_price_1.OfferMainPrice,
];
